module.exports = __webpack_public_path__ + "img/C00080.e6874514.png";